export const cleanArray = (arr: string[]) => {
  return Array.from(new Set(arr.filter(item => item && item.trim() !== '')));
};